import { MediaPackProgram, RbcCircleRec } from '@calm/evexia-web-sdk';
import { useActiveCircleId } from '@rhg/hooks/use-active-circle';
import { useProgram } from '@rhg/hooks/use-program';
import { LearnWhyButton } from '../learn-why-button';
import { ProgramCard, ProgramCardProps } from '../program-card';
import StopPropagation from '../stop-propagation';

export interface PackProgramCardProps
    extends Partial<Omit<ProgramCardProps, 'program'>> {
    variant: ProgramCardProps['variant']; // Makes this required
    recommendation?: RbcCircleRec;
    packProgram: MediaPackProgram;
    packClass: string;
}
export function PackProgramCard({
    packProgram,
    packClass,
    recommendation,
    ...programCardProps
}: PackProgramCardProps) {
    const { activeCircleId } = useActiveCircleId();
    const { program } = useProgram(
        packProgram.programId,
        packClass,
        activeCircleId
    );

    if (!program) return null;

    return (
        <ProgramCard
            contentType={packProgram.contentType}
            program={program}
            {...programCardProps}
            packProgram={packProgram}
            packClass={packClass}
            additionalAction={
                !!recommendation && (
                    <StopPropagation>
                        <LearnWhyButton
                            packProgram={packProgram}
                            recommendation={recommendation}
                            program={program}
                        />
                    </StopPropagation>
                )
            }
        />
    );
}

type NonClickableProps = Pick<
    PackProgramCardProps,
    'packProgram' | 'workflow' | 'packClass' | 'sx'
> & {
    role?: string;
    'aria-label'?: string;
};
export function PackProgramCardNonClickable({
    packProgram,
    workflow,
    packClass,
    sx,
    role,
    'aria-label': ariaLabel,
}: NonClickableProps) {
    return (
        <PackProgramCard
            CardProps={{
                role,
                'aria-label': ariaLabel,
            }}
            variant="horizontal"
            packProgram={packProgram}
            workflow={workflow}
            packClass={packClass!}
            isNotClickable
            sx={sx}
        />
    );
}
